"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CameraIcon = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
function CameraIcon(_a) {
    var { color } = _a, props = __rest(_a, ["color"]);
    const theme = (0, react_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 30 30", fill: "none" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.5 20.7989C20.5 21.462 19.8553 21.9656 19.1739 21.9656L5.23385 22C4.55241 22 4 21.4625 4 20.7994V9.20067C4 8.53757 4.55241 8.00002 5.23385 8.00002L19.1739 7.96558C19.8553 7.96558 20.5 8.46914 20.5 9.13224L20.5039 12.2079C20.5043 12.5667 20.8714 12.8082 21.2011 12.6667L26.6056 10.347C27.2655 10.0637 28 10.5477 28 11.2659V18.717C28 19.4382 27.2597 19.9222 26.599 19.6331L21.2043 17.2718C20.8742 17.1273 20.5043 17.3688 20.5039 17.7292L20.5 20.7989Z", stroke: color !== null && color !== void 0 ? color : theme.colors.grey90, strokeWidth: "2" }) })));
}
exports.CameraIcon = CameraIcon;
//# sourceMappingURL=camera_icon.js.map